/* eslint-disable react/prop-types */
import React from "react";

export const EyeIcon = ({ onClick }) => {
	return (
		<svg onClick={onClick} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M15.125 12.0002C15.125 12.844 14.7958 13.6534 14.2097 14.2501C13.6237 14.8468 12.8288 15.182 12 15.182C11.1712 15.182 10.3763 14.8468 9.79029 14.2501C9.20424 13.6534 8.875 12.844 8.875 12.0002C8.875 11.1563 9.20424 10.347 9.79029 9.75029C10.3763 9.15359 11.1712 8.81836 12 8.81836C12.8288 8.81836 13.6237 9.15359 14.2097 9.75029C14.7958 10.347 15.125 11.1563 15.125 12.0002Z"
				fill="white"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2 12C2 12 5.75 5 12 5C18.25 5 22 12 22 12C22 12 18.25 19 12 19C5.75 19 2 12 2 12ZM12 16.4545C13.1603 16.4545 14.2731 15.9852 15.0936 15.1498C15.9141 14.3144 16.375 13.1814 16.375 12C16.375 10.8186 15.9141 9.68555 15.0936 8.85016C14.2731 8.01477 13.1603 7.54545 12 7.54545C10.8397 7.54545 9.72688 8.01477 8.90641 8.85016C8.08594 9.68555 7.625 10.8186 7.625 12C7.625 13.1814 8.08594 14.3144 8.90641 15.1498C9.72688 15.9852 10.8397 16.4545 12 16.4545Z"
				fill="white"
			/>
		</svg>
	);
};
